import { capitalize } from '@frontend/duck-tape';
import type { SubscriptionTerminologyConfig } from './subscriptionTerminologySchema';

/**
 * Transform a credit-related description to use the appropriate terminology.
 *
 * When credits are hidden (bandwidth mode), replaces all occurrences of
 * "credit/credits/Credit/Credits" with the configured unit term.
 *
 * @param description - The original description text (e.g., "10 credits added")
 * @param pricingTerminology - The terminology config determining how to transform
 * @returns The transformed description
 */
export const transformCreditDescription = (
  description: string,
  pricingTerminology: SubscriptionTerminologyConfig,
): string => {
  if (!pricingTerminology.hide_credits) {
    return description;
  }

  return description.replace(/credits?/gi, (match) => {
    const isPlural = match.toLowerCase().endsWith('s');
    const replacement = isPlural ? pricingTerminology.unit_term_plural : pricingTerminology.unit_term;
    return match[0] === 'C' ? capitalize(replacement) : replacement;
  });
};
